import React, { useEffect,useState } from "react";
import axiosInstance from "../../server/axios.js";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip,ResponsiveContainer,Legend,BarChart,Bar   } from 'recharts';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 1,
};
const Company_sub = () => {
  const location = useLocation(); // 추가된 부분
  const companyCode = location.state?.data; // 추가된 부분

  const companytype = companyCode[1] === 'buy' ? '매입' : '매출';
  const companyname = companyCode[2];
    //firstchart
  const [ChartYearData, setChartYearData] = useState([]);
  const [ChartTitle, setChartTitle ] = useState([]);

  //secondchart
  const [ChartMonthTitle, setChartMonthTitle ] = useState([]);
  const [ChartMonthData, setChartMonthData] = useState([]);

  const [ChartTitleUse, setChartTitleUse ] = useState([]);
  const [ChartDataUse, setChartDataUse] = useState([]);

  //firsttable product list
  const [Weight, setWeight] = useState('yes');
  const [TableTitle, setTableTitle] = useState([]);
  const [TableData, setTableData] = useState([]);

  //secondtable compare table
  const [compareTitle, setcompareTitle] = useState([]);
  const [compareData, setcompareData] = useState([]);
  const [comparePartData, setcomparePartData] = useState([]);
  const [comparePartTitle, setcomparePartTitle] = useState([]);

  //thirdtable lastday table
  const [LastdayDate, setLastdayDate] = useState([]);

  //chartSelection
  const [formats, setFormats] = useState([]);
  const [dataColor, setdataColor] = useState(['red','blue','green','purple','magenta','orange','brown','coral']);

  //tableSelection
  const [alignment, setAlignment] = useState('weight');

  useEffect(()=>{
    getChartdata()
    async function getChartdata(){
      const Chartdata = await axiosInstance.get(`/company/searchcompany?userid=kim&companytype=${companyCode[1]}&companycode=${companyCode[0]}`);
      const YearChartdata = [];
      setChartTitle([Chartdata.data.chartname[0], Chartdata.data.chartname[1], Chartdata.data.chartname[2]]);
      for(let i = 0; i < Chartdata.data.chartdata.length; i++){
        const obj = {
          [Chartdata.data.chartname[0]] : Chartdata.data.chartdata[i][0] ,
          [Chartdata.data.chartname[1]] : Chartdata.data.chartdata[i][1] ,
          [Chartdata.data.chartname[2]] : Chartdata.data.chartdata[i][2]
        }
        YearChartdata.push(obj);
      }
      setChartYearData([...YearChartdata]);

      setChartMonthTitle([
        Chartdata.data.comparerevenuemenu[0],
        Chartdata.data.comparerevenuemenu[1],
        Chartdata.data.comparerevenuemenu[2],
        Chartdata.data.comparerevenuemenu[3],
        Chartdata.data.comparerevenuemenu[4],
        Chartdata.data.comparerevenuemenu[5],
        Chartdata.data.comparerevenuemenu[6]
      ])
      setFormats([Chartdata.data.comparerevenuemenu[5],Chartdata.data.comparerevenuemenu[6]])


      const MonthChartdata = [];
      const MonthChartUse = [];
      for(let i = 0; i < Chartdata.data.comparerevenuedata.length-1; i++){
        const obj = {
          [Chartdata.data.comparerevenuemenu[0]] : Chartdata.data.comparerevenuedata[i][0],
          [Chartdata.data.comparerevenuemenu[1]] : Chartdata.data.comparerevenuedata[i][1],
          [Chartdata.data.comparerevenuemenu[2]] : Chartdata.data.comparerevenuedata[i][2],
          [Chartdata.data.comparerevenuemenu[3]] : Chartdata.data.comparerevenuedata[i][3],
          [Chartdata.data.comparerevenuemenu[4]] : Chartdata.data.comparerevenuedata[i][4],
          [Chartdata.data.comparerevenuemenu[5]] : Chartdata.data.comparerevenuedata[i][5],
          [Chartdata.data.comparerevenuemenu[6]] : Chartdata.data.comparerevenuedata[i][6] 
        }
        MonthChartdata.push(obj);

        const USEobj = {
          [Chartdata.data.comparerevenuemenu[0]] : Chartdata.data.comparerevenuedata[i][0],
          [Chartdata.data.comparerevenuemenu[1]] : 0,
          [Chartdata.data.comparerevenuemenu[2]] : 0,
          [Chartdata.data.comparerevenuemenu[3]] : 0,
          [Chartdata.data.comparerevenuemenu[4]] : 0,
          [Chartdata.data.comparerevenuemenu[5]] : Chartdata.data.comparerevenuedata[i][5],
          [Chartdata.data.comparerevenuemenu[6]] : Chartdata.data.comparerevenuedata[i][6] 
        }
        MonthChartUse.push(USEobj);
      }
      setChartMonthData([...MonthChartdata]);
      setChartTitleUse([...Chartdata.data.comparerevenuemenu]);
      //setChartTitleUse([Chartdata.data.comparerevenuemenu[0],Chartdata.data.comparerevenuemenu[5],Chartdata.data.comparerevenuemenu[6]]);
      setChartDataUse([...MonthChartUse]);
    }
  },[])

  useEffect(()=>{
    getTableData();
    async function getTableData(){
      const table_Data = await axiosInstance.get(`/company/searchcompanytable?userid=kim&companytype=${companyCode[1]}&companycode=${companyCode[0]}&weight=${Weight}`);
      const tabledata = [];
      for(let i = 0; i < table_Data.data.companysalesdata.length; i++){
       const dataArr = [];
       for(let j = 0; j < table_Data.data.companysalesdata[0].length; j++){
         if(j > 2){
           dataArr.push(Math.round(Number(table_Data.data.companysalesdata[i][j])*100)/100); 
           continue;
         }
         dataArr.push(table_Data.data.companysalesdata[i][j]);
       }
       tabledata.push(dataArr);
     }
      setTableTitle([...table_Data.data.companysalesmenu]);
      setTableData([...tabledata]);
    }
  },[Weight])

  useEffect(()=>{
    getCompareData();
    async function getCompareData(){
      const compare_Data = await axiosInstance.get(`/company/comparesalesproduct?userid=kim&companycode=${companyCode[0]}&companytype=${companyCode[1]}`);
      const compareData = [];
        const comparePartData = [];
        for(let i = 0; i < compare_Data.data.comparelastyeardata.length; i++){
          compareData.push([
            compare_Data.data.comparelastyeardata[i].productname,
            compare_Data.data.comparelastyeardata[i].productcode,
            compare_Data.data.comparelastyeardata[i].threeweight,
            compare_Data.data.comparelastyeardata[i].threecost,
            compare_Data.data.comparelastyeardata[i].threepartweight,
            compare_Data.data.comparelastyeardata[i].threepartcost,
            compare_Data.data.comparelastyeardata[i].twoweight,
            compare_Data.data.comparelastyeardata[i].twocost,
            compare_Data.data.comparelastyeardata[i].twopartweight,
            compare_Data.data.comparelastyeardata[i].twopartcost,
            compare_Data.data.comparelastyeardata[i].oneweight,
            compare_Data.data.comparelastyeardata[i].onecost,
            compare_Data.data.comparelastyeardata[i].onepartweight,
            compare_Data.data.comparelastyeardata[i].onepartcost,
            compare_Data.data.comparelastyeardata[i].thisweight,
            compare_Data.data.comparelastyeardata[i].thiscost
          ])
          const checkNotSell = compare_Data.data.comparelastyeardata[i].oneweight + compare_Data.data.comparelastyeardata[i].thisweight;
          if(checkNotSell !== 0 ){

            const oneweight = compare_Data.data.comparelastyeardata[i].oneweight;
            const onecost = compare_Data.data.comparelastyeardata[i].onecost;
            const thisweight = compare_Data.data.comparelastyeardata[i].thisweight;
            const thiscost =  compare_Data.data.comparelastyeardata[i].thiscost;
            
            comparePartData.push([
              compare_Data.data.comparelastyeardata[i].productname,
              compare_Data.data.comparelastyeardata[i].productcode,
              Math.round(oneweight*100)/100,
              Math.round(onecost),
              Math.round(thisweight*100)/100,
              Math.round(thiscost),
              Math.round((thisweight-oneweight)*100)/100,
              Math.round(thiscost-onecost),
              Math.round((1-((onecost-thiscost)/onecost))*10000)/100
            ])
          }
        }
        comparePartData.sort((a,b)=> {
          if(a[0] === '합 계')return 2;
          if(a[8] > b[8])return 1;
          if(a[8] < b[8])return -1;
          } 
        );
        setcompareTitle([...compare_Data.data.comparelastyearmenu]);
        setcomparePartTitle([compare_Data.data.comparelastyearmenu[5],compare_Data.data.comparelastyearmenu[7]])
        setcomparePartData([...comparePartData]);
        setcompareData([...compareData]);
    }
  },[])

  useEffect(()=>{
    getSalesDay();
    async function getSalesDay(){
      const salesDay = await axiosInstance.get(`/company/companylastdate?companycode=${companyCode[0]}&companytype=${companyCode[1]}`);
      const objectLength = salesDay.data.length;
      const today = new Date();
      const lastdaydata = [];
      const getDateDiff = (d1, d2) => {
        const date1 = new Date(d1);
        const date2 = new Date(d2);
        const diffDate = date1.getTime() - date2.getTime();
        return Math.floor(Math.abs(diffDate / (1000 * 60 * 60 * 24)))+' 일'; // 밀리세컨 * 초 * 분 * 시 = 일
      }
      for(let i = 0; i < objectLength; i++){
        const caldate = getDateDiff(today, salesDay.data[i].lastday);
        const count = Number(salesDay.data[i].count);
        const obj = {
          materialname: salesDay.data[i].materialname,
          materialcode: salesDay.data[i].materialcode,
          weight: salesDay.data[i].weight,
          lastday: salesDay.data[i].lastday,
          checkdate : caldate,
          count : count
        };
        lastdaydata.push(obj);
      }
      setLastdayDate([...lastdaydata]);
    }
  },[])
  //multi select button
  const handleFormat = (event, newFormats) => {
    const CheckLength = newFormats.length;
    const newChartTitle = [];
    const newChartdata = [];
    for(let i = 0; i < CheckLength; i++){
      if(i === 0){newChartTitle.push(ChartMonthTitle[0]);}
      newChartTitle.push(newFormats[i]);
    }
    const newChartDrawTitle = [];
    for(let i = 0; i < ChartTitleUse.length; i++){
      const index = newChartTitle.indexOf(ChartTitleUse[i]);
      if(index === -1){
        newChartDrawTitle.push(0);
        continue;
      }
      newChartDrawTitle.push(ChartTitleUse[i]);
    }
    for(let i = 0; i < ChartMonthData.length; i++){
      const obj = {};
      for(let j = 0; j < newChartDrawTitle.length; j++){
        if(j === 0){
          obj['Month']=ChartMonthData[i].Month;
          continue;
        }
        if(newChartDrawTitle[j] === 0 ){
          obj[ChartTitleUse[j]]=0;
        }else{
          obj[newChartDrawTitle[j]]=ChartMonthData[i][newChartDrawTitle[j]];
        }
      }
      newChartdata.push(obj);
    }
    setChartDataUse([...newChartdata]);
    setFormats(newFormats);
  };

  //single select button
  const handleAlignment = (event, newAlignment) => {
    let check = newAlignment;
    if(newAlignment === null){check = alignment;}

    if(check === 'weight'){
      setWeight('yes')
    }else{
      setWeight('no')
    }
    setAlignment(check);
  };
  const DataFormater = (number) => {
    if(number === 0){return '';}
    if(number === null){return '';}
    if(number >= 100000000){
      const checknumber = Math.round(number/100000000*100)/100;
      return checknumber+'억';
    }else if(number > 10000){
      const checknumber = Math.round(number/10000);
      return checknumber+'만';
    }
    if(number >= -100000000){
      const checknumber = Math.round(number/100000000*100)/100;
      return checknumber+'억';
    }else if(number > -10000){
      const checknumber = Math.round(number/10000);
      return checknumber+'만';
    }else{
      return number+'';
    }
  }
  const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill={'black'} textAnchor="middle" fontSize={13} dy={-6}>{`${DataFormater(value)}`}</text>;
  };
  const commaNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const sortingTable = (sortingnumber) => {
    const checkingSort = TableTitle[sortingnumber].indexOf('\n🔻');
    const dummyMenu = [];
    for(let i = 0; i < TableTitle.length; i++){
      let menu = TableTitle[i];
      menu = menu.replace(/\n🔺/gi, '');
      menu = menu.replace(/\n🔻/gi, '');
      if(i === sortingnumber){
        menu = checkingSort === -1 ? menu + '\n🔻' : menu = menu + '\n🔺';
      }
      dummyMenu.push(menu);
    }
    const sortDirection = (sortingnumber,sortmark) =>{
      let checkNumbers = sortingnumber;
      if(sortingnumber >= 1){
        checkNumbers = sortingnumber+1;
      }else{
        checkNumbers = sortingnumber;
      }
      let direction = -1;
      if(sortmark === -1){direction = 1}
      const dummyItemArr = TableData.sort((a, b) => {
        if (a[checkNumbers] < b[checkNumbers])return 1*direction;
        if (a[checkNumbers] > b[checkNumbers])return -1*direction;
        return 0;
        });
      return dummyItemArr;
    }
    const dummyArr = sortDirection(sortingnumber,checkingSort);
    setTableTitle([...dummyMenu])
    setTableData([...dummyArr])
  }
  const renderYearChart = (
    <ResponsiveContainer width='90%' height={400} >
      <BarChart  width={500} height={300} data={ChartYearData} margin={{ top: 10, right: 150, bottom: 5, left: 0 }}>
      <XAxis dataKey={ChartTitle[0]} stroke="#8884d8" />
      <YAxis tickFormatter={DataFormater}/>
      <Tooltip formatter={(value) => new Intl.NumberFormat('en').format(value)} />
      <Legend width={120} wrapperStyle={{ top: 50, right: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '40px',fontSize:13 }} />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <Bar  
        fill={dataColor[0]}
        dataKey={ChartTitle[1]} 
        label={renderCustomBarLabel}
      />
      <Bar  
        fill={dataColor[1]}
        dataKey={ChartTitle[2]} 
        label={renderCustomBarLabel}
      />
    </BarChart >
    </ResponsiveContainer>
  );
  const renderMonthChart = (
    <ResponsiveContainer  minWidth={500} width='90%' height={400} >
      <BarChart  width={500} height={300} data={ChartDataUse} margin={{ top: 10, right: 150, bottom: 5, left: 0 }}>
      <XAxis dataKey={ChartTitleUse[0]} stroke="#8884d8" />
      <YAxis tickFormatter={DataFormater}/>
      <Tooltip  formatter={(value) => new Intl.NumberFormat('en').format(value)}/>
      <Legend width={88} height={1} wrapperStyle={{ top: 50, right: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '40px',fontSize:13 }} />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <Bar  
        fill={dataColor[2]}
        dataKey={ChartTitleUse[1]} 
        label={renderCustomBarLabel}        
      />
      <Bar  
        fill={dataColor[3]}
        dataKey={ChartTitleUse[2]} 
        label={renderCustomBarLabel}         
      />
      <Bar  
        fill={dataColor[4]}
        dataKey={ChartTitleUse[3]} 
        label={renderCustomBarLabel}     
      />
      <Bar  
        fill={dataColor[5]}
        dataKey={ChartTitleUse[4]} 
        label={renderCustomBarLabel}           
      />
      <Bar  
        fill={dataColor[6]}
        dataKey={ChartTitleUse[5]} 
        label={renderCustomBarLabel}        
      />
      <Bar  
        fill={dataColor[7]}
        dataKey={ChartTitleUse[6]} 
        label={renderCustomBarLabel}         
      />
    </BarChart >
    </ResponsiveContainer>
  );

  const handleChange = (event,IndexNumber) => {
    const [ PartTitle1,PartTitle2 ] = comparePartTitle;

    const TitleArr = [];
    const indexArr = [];
    if(IndexNumber === 0){
      TitleArr.push(compareTitle[event.target.value],PartTitle2);
      const secondIndex = compareTitle.indexOf(`${PartTitle2}`);
      indexArr.push(event.target.value,secondIndex);
    }
    if(IndexNumber === 1){
      TitleArr.push(PartTitle1,compareTitle[event.target.value]);
      const firstIndex = compareTitle.indexOf(`${PartTitle1}`);
      indexArr.push(firstIndex,event.target.value);
    }
    setcomparePartTitle([...TitleArr]);
    setCompareData(Number(indexArr[0]),Number(indexArr[1]));

  };
  const setCompareData = (compareIndex1,compareIndex2) => {
    const comparePartData = [];

    const checkIndex = [[2,3],[4,5],[6,7],[8,9],[10,11],[12,13],[14,15]];

    for(let i = 0; i < compareData.length; i++){
      const checkNotSell = compareData[i][checkIndex[compareIndex1-1][0]] + compareData[i][checkIndex[compareIndex2-1][0]];
      if(checkNotSell !== 0 ){

        const oneweight = compareData[i][checkIndex[compareIndex1-1][0]];
        const onecost = compareData[i][checkIndex[compareIndex1-1][1]];
        const thisweight = compareData[i][checkIndex[compareIndex2-1][0]];
        const thiscost =  compareData[i][checkIndex[compareIndex2-1][1]];
        
        comparePartData.push([
          compareData[i][0],
          compareData[i][1],
          Math.round(oneweight*100)/100,
          Math.round(onecost),
          Math.round(thisweight*100)/100,
          Math.round(thiscost),
          Math.round((thisweight-oneweight)*100)/100,
          Math.round(thiscost-onecost),
          Math.round((1-((onecost-thiscost)/onecost))*10000)/100
        ])
      }
    }
    comparePartData.sort((a,b)=> {
      if(a[0] === '합 계')return 2;
      if(a[8] > b[8])return 1;
      if(a[8] < b[8])return -1;
      } 
    );
    setcomparePartData([...comparePartData]);
  }
  const compareButton1 = (
    <FormControl >
    <NativeSelect
      defaultValue={5}
      onChange={(e)=>handleChange(e,0)}
    >
      <option value={1}>{compareTitle[1]}</option>
      <option value={2}>{compareTitle[2]}</option>
      <option value={3}>{compareTitle[3]}</option>
      <option value={4}>{compareTitle[4]}</option>
      <option value={5}>{compareTitle[5]}</option>
      <option value={6}>{compareTitle[6]}</option>
      <option value={7}>{compareTitle[7]}</option>
    </NativeSelect>
  </FormControl>
  );
  const compareButton2 = (
    <FormControl >
    <NativeSelect
      defaultValue={7}
      onChange={(e)=>handleChange(e,1)}
    >
      <option value={1}>{compareTitle[1]}</option>
      <option value={2}>{compareTitle[2]}</option>
      <option value={3}>{compareTitle[3]}</option>
      <option value={4}>{compareTitle[4]}</option>
      <option value={5}>{compareTitle[5]}</option>
      <option value={6}>{compareTitle[6]}</option>
      <option value={7}>{compareTitle[7]}</option>
    </NativeSelect>
  </FormControl>
  );



  //modal
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalTitle, setModalTitle] = useState([]);
  const handleOpen = (materialcode, materialprice, companycode, datatype, pricetype, searchdate,materialname,companyname) =>{ 
    const price = pricetype === 'yes' ? 'kg' : 'won';
    async function getInfoData(){
      const handleData = await axiosInstance.get(`/material/infobydate?materialcode=${materialcode}&materialprice=${materialprice}&companycode=${companycode}&datatype=${datatype}&pricetype=${price}&searchdate=${searchdate}`);
      const title = [companyname,materialname].concat(handleData.data.menu).flat();
      const getSumData = [];
      const sumData = {yeardate:'합 계',companyname:'',weight:0,price:0,sumresult:0};
      for(let i = 0; i < handleData.data.list.length; i++){
        const newYearDate = handleData.data.list[i].yeardate;
        const newCompanyName = handleData.data.list[i].companyname;
        const newWeight = (handleData.data.list[i].weight);
        const newPrice = (handleData.data.list[i].price);
        const newSumresult = (handleData.data.list[i].sumresult);
        const obj ={
          yeardate:newYearDate,
          companyname:newCompanyName,
          weight:newWeight,
          price:newPrice,
          sumresult:newSumresult
        }
        sumData['weight'] = sumData.weight + Number(newWeight);
        sumData['price'] = Math.round(sumData.price + Number(newPrice));
        sumData['sumresult'] = Math.round(sumData.sumresult+Number(newSumresult));
        getSumData.push(obj)
      }
      getSumData.push(sumData)
      setModalTitle([...title]);
      setModalData([...getSumData]);
    }
    getInfoData();
    setOpen(true)
  };
  const handleClose = () => setOpen(false);



  return (
      <div className="company_sub">
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="modalbox">
                <table className="company_main">
                  <tr><th colSpan={5}>{modalTitle[0]} {modalTitle[1]} </th></tr>
                  <tr>
                    <th>{modalTitle[2]}</th>
                    <th>{modalTitle[4]}</th>
                    <th>{modalTitle[5]}</th>
                    <th>{modalTitle[6]}</th>
                  </tr>
                  {modalData.map((val,i)=>
                  <tr>
                    <td>{val.yeardate}</td>
                    <td className="companysales">{commaNumber(val.weight)}</td>
                    <td className="companysales">{commaNumber(val.price)}</td>
                    <td className="companysales">{commaNumber(val.sumresult)}</td>
                  </tr>
                  )}
                </table>
              </div>
            </Box>
          </Modal>
 
          <div className="chartbox">
            <div className="chartcontents">{companyCode[2]} : {companyCode[0]}</div>
            <br></br>            <br></br>    
            <div>{companyname} 연도별 {companytype}</div>
            <div className="chartcontents">{renderYearChart}</div>
            <br></br>            <br></br>    
            <div>{companyname} 월별 {companytype}</div>
            <div className="chartcontents">{renderMonthChart}</div>
                          <div>
                <ToggleButtonGroup
                  color="primary"
                  value={formats}
                  onChange={handleFormat}
                  aria-label="text formatting"
                >
                  <ToggleButton value={ChartMonthTitle[1]} aria-label={ChartMonthTitle[1]}>
                  {ChartMonthTitle[1]} 
                  </ToggleButton>
                  <ToggleButton value={ChartMonthTitle[2]} aria-label={ChartMonthTitle[2]}>
                  {ChartMonthTitle[2]} 
                  </ToggleButton>
                  <ToggleButton value={ChartMonthTitle[3]} aria-label={ChartMonthTitle[3]}>
                  {ChartMonthTitle[3]} 
                  </ToggleButton>
                  <ToggleButton value={ChartMonthTitle[4]} aria-label={ChartMonthTitle[4]}>
                  {ChartMonthTitle[4]} 
                  </ToggleButton>
                  <ToggleButton value={ChartMonthTitle[5]} aria-label={ChartMonthTitle[5]}>
                  {ChartMonthTitle[5]} 
                  </ToggleButton>
                  <ToggleButton value={ChartMonthTitle[6]} aria-label={ChartMonthTitle[6]}>
                  {ChartMonthTitle[6]} 
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>
          </div>

          <br></br><br></br><br></br><br></br>
              <div className="table_menu">
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleAlignment}
              aria-label="text alignment"
            >
              <ToggleButton value="weight" aria-label="weight">
              Weight
              </ToggleButton>
              <ToggleButton value="price" aria-label="price">
              Price
              </ToggleButton>
            </ToggleButtonGroup>
            <table className="company_main">
              <tr>
                {TableTitle.map((val,i)=>
                  i === 0 ?
                  <th className="toptable"><div className="underline" onClick={()=>sortingTable(i)}>{val}</div></th>
                  :
                  i === 1 && Weight === 'no'?
                  <td className="hide"></td>
                  :
                  <th><div className="underline" onClick={()=>sortingTable(i)}>{val}</div></th>
                )}
              </tr>
              {TableData.map((arrdata,i)=>
                <tr>{
                  arrdata.map((val,i,arr)=>
                  i === 0 ? 
                  <td className="companyname">
                    {
                    val !== '합 계' ?
                    <Link to='/Company_sub_material' state={{ data: [arr[0],arr[1]]}} style={{ textDecoration: "none"}}>
                    <div className="rightline" title={val}>{val}</div>
                    </Link> 
                    :
                    <div className="rightline">{val}</div>
                  }
                  </td>
                  :
                  i === 1 ? 
                  <td className="hide"></td>
                  :
                  i === 2 && Weight === 'no'?
                  <td className="hide"></td>
                  :
                  i === 2 && Weight === 'yes'?
                  <td className="companysales">{commaNumber(val)}</td>
                  :
                  i > 2 && val === 0 ? 
                  <td className="companysales"></td> 
                  :
                  arr[0] === '합 계'? 
                  <td className="companysales">{commaNumber(val)}</td>
                  :
                  <td className="companysales" style={{backgroundColor:'beige',cursor:'pointer'}} onClick={()=>handleOpen(arr[1],arr[2],companyCode[0],companyCode[1],Weight,TableTitle[i-1],arr[0],companyCode[2])}>{commaNumber(val)}</td>
                 )
                }
                </tr>
             )}
            </table>
          </div>

          <br></br><br></br>

          <table className="company_main">
              <tr>
                <th rowSpan={2} className="toptable">
                  <div className="underline"> 
                    {companyname}<br></br>
                    품목별 {companytype}<br></br>
                    비교
                  </div>
                </th>
                <th colSpan={2}><div className="underline">{compareButton1}</div></th>
                <th colSpan={2}><div className="underline">{compareButton2}</div></th>
                <th rowSpan={2}><div className="underline">kg<br></br>차이</div></th>
                <th rowSpan={2}><div className="underline">금액<br></br>차액</div></th>
                <th rowSpan={2}><div className="underline">금액 <br></br>%비교</div></th>
              </tr>
              <tr>
               <th style={{top:"36px",position:"sticky"}}><div className="underline">{comparePartTitle[0]} <br></br> kg</div></th>
               <th style={{top:"36px",position:"sticky"}}><div className="underline">{comparePartTitle[0]} <br></br>금액</div></th>
               <th style={{top:"36px",position:"sticky"}}><div className="underline">{comparePartTitle[1]}<br></br> kg</div></th>
               <th style={{top:"36px",position:"sticky"}}><div className="underline">{comparePartTitle[1]} <br></br>금액</div></th>
              </tr>
              {comparePartData.map((arrdata)=>
                <tr>
                  {arrdata.map((val,i,arr)=>
                      i === 0 ?
                      <td className="companyname">
                      {
                      val !== '합 계' ?
                      <Link to='/Company_sub_material' state={{ data: [arr[0],arr[1]]}} style={{ textDecoration: "none"}}>
                      <div className="rightline" title={val}> {val}</div>
                      </Link> 
                      :
                      <div className="rightline">{val}</div>
                      }
                      </td>
                      :
                      i === 1 ? 
                      <td className="hide"></td>
                      :
                      <td className="companysales">{val === 0 ? '-' : commaNumber(val)}</td>
                    ) 
                  }
                </tr>
             )}
            </table>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
            <table className="company_main">
              <tr><th colSpan={5}>{companyname} 품목별 {companytype} 이후 지난 시간</th></tr>
              <tr>
                <th className="toptable"><div className="underline">품목</div></th>
                <th><div className="underline">최근 판매량</div></th>
                <th><div className="underline">최근 판매일</div></th>
                <th><div className="underline">판매후 지난 일</div></th>
                <th><div className="underline">비고</div></th>
              </tr>
              {LastdayDate.map((objectArr)=>
                <tr>
                  <td className="companyname"><div className="rightline" title={objectArr.materialname}>{objectArr.materialname}</div></td>
                  <td className="companysales">{commaNumber(objectArr.weight)}</td>
                  <td>{objectArr.lastday}</td>
                  <td>{objectArr.checkdate}</td>
                  <td>{ objectArr.count === 1 ? '1회성 판매' : ''}</td>
                </tr>
                )
              }
            </table>

            <br></br>
            <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
            <div className="openlink" 
            onClick={()=>window.open("https://docs.google.com/spreadsheets/d/10Y_DTub6NG8holqSQYrWJflrN9uVkERg_ujRA0uY0bc/edit?usp=sharing",
                                    'targetWindow',
                                   `scrollbars=yes,resizable=yes,width=1000px,height=600px`)}
                                    ><h1>견본 LINK TEST</h1>
            </div>
            <br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
        </div>
    );
}
export default Company_sub;